import { render, staticRenderFns } from "./PelatihanPostTestReport.vue?vue&type=template&id=6e603042"
import script from "./PelatihanPostTestReport.vue?vue&type=script&lang=js"
export * from "./PelatihanPostTestReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports